import render from './render'

export default {
  name: 'Voice',

  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  data() {
    return {
      voiceBars: [],
      barsInterval: undefined,

      timer: 0,
      timeInterval: undefined
    }
  },

  computed: {
    time() {
      const mins = Math.floor(this.timer / 60).toString()
      const secs = (this.timer % 60).toString()

      return `${mins.padStart(2, '0')}:${secs.padStart(2, '0')}`
    }
  },

  watch: {
    'value.type'() {
      this.cleanup()
      this.setVoiceBars()
      this.startTimer()
    }
  },

  mounted() {
    this.setVoiceBars()
    this.startTimer()
  },

  beforeDestroy() {
    this.cleanup()
  },

  methods: {
    startBarsAnimation() {
      this.barsInterval = setInterval(() => {
        this.voiceBars = [ ...this.voiceBars.slice(1), this.generateBarHeight() ]
      }, 100)
    },

    generateBarHeight() {
      const containerHeight = this.$refs.track.clientHeight

      return Math.max(4, Math.random() * containerHeight / 2)
    },

    setVoiceBars() {
      if (this.$refs.track) {
        const container = this.$refs.track
        const containerWidth = container.clientWidth

        const barCount = Math.floor(containerWidth / 5)

        this.voiceBars = Array.from({ length: barCount }, () => {
          return this.generateBarHeight()
        })

        this.startBarsAnimation()
      }
    },

    startTimer() {
      this.timeInterval = setInterval(() => {
        this.timer++
      }, 1000)
    },

    cleanup() {
      this.voiceBars = []
      this.timer = 0
      this.removeInterval(this.barsInterval)
      this.removeInterval(this.timeInterval)
    },

    removeInterval(interval) {
      if (interval) {
        clearInterval(interval)
      }
    }
  },

  render
}
